
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/neurology",
      function () {
        return require("private-next-pages/neurology.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/neurology"])
      });
    }
  